import '../internals/custom-jquery';
import './form';
import './global';
import './acf/kg-numeric-slider';
import './acf/kg-commentaires';

/**
 * Function utilisée sur le formulaire "Postuler"
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { DemandeNounou : {}});
    
    /**
     * Initialisation du formulaire
     */
    w.Kinougarde.DemandeNounou.initFormulaireTarif = function() {        
                              
        //Valeur par défaut du formulaire
        Kinougarde.DemandeNounou.nbEnfant = 1; 
        Kinougarde.DemandeNounou.nbEnfantMax = 5;         
        
        var defaultDataNounou = Kinougarde.GetStorage("form-demande-nounou");
        var defaultDataSimulation = Kinougarde.GetStorage("form-simulation-budgetaire");
        if (defaultDataNounou!==null) {
            // Retrouve le nombre d'enfant du formulaire demande nounou precedent
            var proprieteEnfants =  Object.keys(defaultDataNounou)
                                .filter(p => p.match(/enfant\d+_/))
                                .map( (value,index)=> { return value.match(/enfant(\d+_)/)[1];})
                                .filter((value, index, self)=> {return self.indexOf(value) === index;});
            for (let index = 1; index < proprieteEnfants.length; index++){
                // Ajout des enfants supplementaires
                Kinougarde.DemandeNounou.AjoutBlocEnfant(proprieteEnfants[index]);    
            }

        }
        else if (defaultDataSimulation!==null) {
            // On utilise les données de simulation budgétaire
            for (let index = 1; index < parseInt(defaultDataSimulation.nombre_enfant); index++){
                // Ajout des enfants supplementaires
                var prefixe = Math.random().toString(10).slice(2, 8) + "_";
                Kinougarde.DemandeNounou.AjoutBlocEnfant(prefixe);    
                
                /**
                 * ATTENTION pour que les données par défaut soit récupérées du formulaire simulation budgetaires,
                 * Les champs suivants doivent avoir le même "name" dans les deux formmulaires :
                 *   nom, adresse, telephone, email                 
                 */
            }
            defaultDataNounou = defaultDataSimulation;
        }
        

        Kinougarde.formulaireAcf.InitFormulaire({ defaultValue : defaultDataNounou} );        
                
        //Ajout du Titre "Mes bout'chous"
        $("#etape_enfant .form-step").first().before("<h2 class=\"bold-label\">Mes bout'chous</h2>")
        // Ajout du lien "Ajouter un enfant"
        $("#etape_enfant .form-step").last().after("<div class=\"ajouter-enfant\"><a href=\"#\" id=\"ajouter_enfant\">+ Ajouter un enfant</a></div>");

        // Click sur ajouter un enfant
        $("#ajouter_enfant").on('click',function(ev) {
            ev.preventDefault();            
            var prefixe = Math.random().toString(10).slice(2, 8) + "_";
            Kinougarde.DemandeNounou.AjoutBlocEnfant(prefixe);        
            if (Kinougarde.DemandeNounou.nbEnfant>=Kinougarde.DemandeNounou.nbEnfantMax) {$(this).hide();} 
        })


          // Capte le click sur "Envoyer ma demande" de l'étape Coordonnées
        // Avant le changement d'étape
        $('#etape_coordonnees').on('form-step-next-change',function(event,options) {                       
            //Modifie les options par défaut qui seront utilisés pour le passage à l'étape suivante
            if (Kinougarde.GetStorage("form-simulation-budgetaire-ti")!=null) {
                // Inject l'Id de la TiDevisGe sur la demande
                options.data =  {'IdTransactionPrecedente' : Kinougarde.GetStorage("form-simulation-budgetaire-ti")};            
            }
            return options;            
        });

        // Capte les évènements ajax-action-success sur l'étape des coordonnées
        // Après le changement d'étape
        $("#etape_coordonnees").on("form-step-next-changed", function(e,reponse,data) {
            // Mémorise les données du formulaire pour une prochaine utilisation
            // se base sur le consentement de l'utilisateur
            Kinougarde.SetStorage("form-demande-nounou",data);            
        });


    };   

    /**
     * Ajoute dynamiquement un bloc enfant
     * @param {} index 
     */
    w.Kinougarde.DemandeNounou.AjoutBlocEnfant = function(prefixe ) {
        
        // Refresh des composants pour la validation
        // On recupère le bloc N°1 et on le duplique en changeant les id et name enfant1 par enfant+hash
        var bloc1 = $("#etape_enfant .form-step").first()[0].outerHTML;        
        var nouveauHtml = bloc1.replace(/((id|name|for|data-parsley-multiple)="enfant)1_/gm,"$1"+ prefixe);
        Kinougarde.DemandeNounou.nbEnfant++;
        nouveauHtml = nouveauHtml.replace(/1er enfant/gm,Kinougarde.DemandeNounou.nbEnfant+"ème enfant");        
        // Insersion du nouveau bloc
        $("#etape_enfant .form-step").last().after(nouveauHtml);
        var nouveauBloc = $("#etape_enfant .form-step").last();
        // Init du nouveau bloc
        nouveauBloc.find(".acf-kg-text .wrapper-input").append("<span class=\"delete-enfant\"></span>");
        w.Kinougarde.InitHtmlComponant(nouveauBloc[0]);                
        nouveauBloc.initKgAcfDate();

        $('.acf-steps form').parsley().refresh();            
                                
        // Supprime le bloc un click
        nouveauBloc.find(".delete-enfant").on('click',function(e) {
            $(this).closest(".form-step").remove();
            Kinougarde.DemandeNounou.nbEnfant--;

            if (Kinougarde.DemandeNounou.nbEnfant<=Kinougarde.DemandeNounou.nbEnfantMax) {$("#ajouter_enfant").show();}
            
            //Renumérotation du champ xème enfant
            $("#etape_enfant .form-step").each(function(index) {
                if (index>0) {
                    $(this).find(".acf-kg-text label").text((index+1) + "ème enfant");
                }
            })
        })
    };          
    
})(window);

jQuery(function() {
    try {
        //Formulaire de "Simulation budgétaire" ou "trouver nounou"
        if (jQuery("#section-demande-nounou").length>0) {               
            Kinougarde.DemandeNounou.initFormulaireTarif();        
        };           
    }     
    catch (ex) {
        console.error(ex);
    }
});